import React from 'react'

// Whether the sidebar is open, provided by the header/sidebar layout for page
// content that is positioned against the window and so can't rely on main's
// margin to clear the sidebar.
export const SidebarContext = React.createContext(false)
